export default __webpack_public_path__ + "static/media/pic9.336da7bf.jpg";